import React, { useState } from 'react';
import { Logger } from '@saviynt/common';
import {
  Box,
  ButtonSelect,
  Icon,
  MenuDragAndDrop,
  Tooltip,
  Typography,
} from '@saviynt/design-system';

import { CF_SEC_BLD } from '../../../../../../shared/constants';
import { RISKS_FILTERS } from '../data-layer/detailsMockData';

import '../../../../../../shared/components/SodColumnsList/SodColumnsList.css';

/**
 * InherentRiskColumnList
 */
function InherentRiskColumnList() {
  const [options, setOptions] = useState(RISKS_FILTERS);
  const [isExpanded, setIsExpanded] = useState(false);

  const onSearchTermChange = (value: string) => {
    Logger.info('searchTerm', value);
  };

  const renderedMenuTrigger = (
    <ButtonSelect
      kind='rectangle'
      color='transparent'
      label='List'
      ariaLabel='List'
      size='small'
      prefixIcon={<Icon kind='Edit' />}
      isVisualCueEnabled={false}
    />
  );

  const detailsPanel = (
    <Tooltip
      trigger={
        <Typography kind='body3' color={CF_SEC_BLD}>
          Details Panel
        </Typography>
      }
      text='Tap anywhere on the row to open the details panel.'
      placement='bottom-start'
    />
  );

  const labelText =
    'The number of visible attributes depends on the size of your browser. Any attributes not shown are visible in the';
  const label = (
    <span>
      {labelText} {detailsPanel}.
    </span>
  );

  return (
    <Box className='SodColumnsList'>
      <MenuDragAndDrop
        label={label}
        options={options}
        setOptions={setOptions}
        trigger={renderedMenuTrigger}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        minOptionsForSearch={2}
        onSearchTermChange={onSearchTermChange}
      />
    </Box>
  );
}

export default InherentRiskColumnList;
